<template>
  <SectionCard :id="section.id" :title="section.title">
    <MortgageDeedsOverview :mortgage-deeds="mortgageDeeds" :new-mortgage-deeds-cost="newMortgageDeedsCost" />
  </SectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { SectionCard, MortgageDeedsOverview } from '@staff/ui'
import { useRequiredApplication } from '@/views/application/application.context'
import { isRealEstateCollateral } from '@/utils/applicationDisplay'
import type { ApplicationSections } from './sections'

defineProps<{
  section: ApplicationSections['mortgageDeeds']
}>()

const application = useRequiredApplication()

const collateral = computed(() => application.value.collateralProperty)

const mortgageDeeds = computed(() =>
  isRealEstateCollateral(collateral.value) ? collateral.value?.mortgageDeeds : undefined,
)

const newMortgageDeedsCost = computed(() =>
  isRealEstateCollateral(collateral.value) ? collateral.value?.newMortgageDeedsCost : undefined,
)
</script>
